<template>
    <div class="tw-w-64 tw-mr-6">
        <div class="tw-h-64 tw-flex transition-medium tw-border tw-border-grey-lighter" :style="thumbnailBackground"
             @click="$emit('clicked')">
            <div class="actionWrapper tw-h-full tw-w-full tw-relative tw-cursor-pointer"
                 @mouseover="handleMouseOver" @mouseleave="handleMouseLeave">
                <template v-if="!noActions">
                    <div class="tw-absolute tw-pin-t tw-pin-l tw-text-white tw-mt-4 tw-ml-5 animated fadeIn"
                         v-if="buttonVisible">
                        <i class="fa fa-arrows-alt"></i>
                    </div>
                    <div class="tw-h-full tw-w-full tw-flex tw-flex-col tw-justify-center tw-items-center animated fadeIn"
                         v-if="buttonVisible">
                        <button class="tw-border tw-border-white tw-py-2 tw-w-32 tw-text-white tw-rounded-lg tw-mb-4"
                                @click="preview">{{ $t('wi.preview') }}
                        </button>
                        <button class="tw-border tw-border-red tw-bg-red tw-py-2 tw-w-32 tw-text-white tw-rounded-lg"
                                @click="remove">{{ $t('wi.remove') }}
                        </button>
                    </div>
                </template>
                <template v-else>
                    <div v-if="buttonVisible"
                         class="animated fadeIn tw-flex tw-h-64 tw-justify-center tw-items-center" @click="preview">
                        <i class="fal fa-play-circle fa-2x tw-text-white tw-opacity-75"></i>
                    </div>
                </template>
            </div>
        </div>
        <div class="tw-mt-2 tw-text-base tw-text-grey-darker tw-w-full" style="white-space: nowrap; overflow: hidden; -ms-text-overflow: ellipsis;text-overflow: ellipsis;">
            {{ video.name }}
        </div>
        <div class="tw-flex tw-justify-between tw-text-grey tw-mt-2 tw-font-thin tw-text-base">
            <span>{{ $t('wi.uploaded') }}:</span>
            <span v-text="formattedUploadedAt"></span>
        </div>
    </div>
</template>

<script>
  import { moment, format } from "../../../moment";

  export default {
    name: "HighlightVideo",
    data() {
      return {
        buttonVisible: false,
      }
    },
    props: {
      video: {type: Object, required: true},
      noActions: {type: Boolean, default: false},
    },
    computed: {
      thumbnailBackground() {
        return {
          backgroundImage: `url(${this.video.thumbnail})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'auto 160px'
        }
      },

      formattedUploadedAt() {
        return moment(this.video.uploadedAt).format(format.date)
      }
    },
    methods: {
      preview() {
        this.$emit('preview', this.video);
      },
      remove() {
        this.$emit('remove', this.video);
      },
      handleMouseOver() {
        this.buttonVisible = true;
      },
      handleMouseLeave() {
        this.buttonVisible = false;
      }
    },
  }
</script>

<style scoped>
    .actionWrapper {
        -webkit-transition: all .5s;
        -moz-transition: all .5s;
        -ms-transition: all .5s;
        -o-transition: all .5s;
        transition: all .5s;
    }

    .actionWrapper:hover {
        background-color: rgba(0, 0, 0, .5);
    }
</style>
